export default __webpack_public_path__ + "static/media/left.4dfb658f.png";